import { proxy, subscribe } from "valtio";

export const navigationStore = proxy<{
    postLoginRedirect: string;
}>({
    postLoginRedirect: localStorage.getItem("postLoginRedirect") ?? '',
});

subscribe(navigationStore, () => {
    console.log("Navigation Store changed:", {
        navigationStore: navigationStore.postLoginRedirect
    });

    if (navigationStore.postLoginRedirect.length > 0) {
        localStorage.setItem("postLoginRedirect", navigationStore.postLoginRedirect);
    } else {
        localStorage.removeItem("postLoginRedirect");
    }
});

